/* eslint-disable jsx-a11y/iframe-has-title */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import styles from './ExcelViewer.scss';
import apiService from '../../../../services/api/ApiService';


class ExcelViewer extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props);
        this.accessTokenInterval = null;
    }

    componentDidMount() {
        const ACCESS_TOKEN_UPDATE_INTERVAL = 3480000;
        this.createPopup({
            title: 'Auto save',
            message: t('popup_auto_save_work'),
            footerButtonText: t('popup_footer_text'),
            footerButtonCallback: () => {
                const popupContainer = document.querySelector('.modal-popup-container');
                if (popupContainer) {
                    popupContainer.remove();
                }
            },
        });

        this.accessTokenInterval = setInterval(this.updateIframeSrc, ACCESS_TOKEN_UPDATE_INTERVAL);
    }

    componentWillUnmount() {
        if (this.accessTokenInterval) {
            clearInterval(this.accessTokenInterval);
        }
    }

    createPopup = ({ title, message, footerButtonText, footerButtonCallback }) => {
        const popupContainer = document.createElement('div');
        popupContainer.classList.add(styles['modal-popup-container']);

        const header = document.createElement('div');
        header.classList.add(styles['modal-popup-header']);
        const titleElement = document.createElement('h2');
        titleElement.innerText = title;
        const closeButton = document.createElement('span');
        closeButton.classList.add(styles['modal-popup-header-close']);
        closeButton.innerHTML = '&times;';
        closeButton.onclick = () => popupContainer.remove();
        header.appendChild(titleElement);
        header.appendChild(closeButton);
        popupContainer.appendChild(header);

        const body = document.createElement('div');
        body.classList.add(styles['modal-popup-body']);
        const messageElement = document.createElement('p');
        messageElement.innerText = message;
        body.appendChild(messageElement);
        popupContainer.appendChild(body);

        const footerButton = document.createElement('button');
        footerButton.classList.add(styles['modal-popup-footer-button']);
        footerButton.innerText = footerButtonText;
        footerButton.onclick = () => {
            if (footerButtonCallback) {
                footerButtonCallback();
            }

            popupContainer.remove();
        };
        popupContainer.appendChild(footerButton);

        document.body.appendChild(popupContainer);
    };

    updateIframeSrc = async () => {
        const iframe = document.getElementById('dynamic-iframe');

        if (iframe == null) {
            return;
        }

        const response = await apiService.fetchSpreadSheetAccessToken();
        if (!response) return;

        const baseURL = iframe.src.split('?')[0];
        const queryParams = new URLSearchParams(iframe.src.split('?')[1]);

        queryParams.set('access_token', response.accessToken);
        queryParams.set('access_token_ttl', `${response.accessTokenTTl}L`);
        iframe.src = `${baseURL}?${queryParams}`;
    };

    render() {
        const { url } = this.props;

        return (
            <div className="excel-viewer-container" style={{ width: '100%', height: '600px', position: 'relative' }}>
                <iframe
                    id="dynamic-iframe"
                    src={url}
                    className={styles['excel-viewer-iframe']}
                    frameBorder="0"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                />
            </div>
        );
    }
}

export default ExcelViewer;
